import { useEffect } from 'react'

import { postFinishTask } from '@/api'
import { store, loginStateAtom } from '@/store'
import { isPWA } from '@/utils'

export const useCompletePWATask = () => {
  const isLogin = store.get(loginStateAtom)
  const handleComplete = async () => {
    postFinishTask({
      trigger_event: 'PWA_START',
      completed_period: 2,
      completed_times: 1,
    })
  }

  useEffect(() => {
    if (isLogin && isPWA()) {
      handleComplete()
    }
  }, [])
}
